import './public-path';
import JsonParseBigInt from 'json-parse-bigint';
import Vue from 'vue';
import iView from 'iview';
import VueRouter from 'vue-router'
import { routes } from './router/router';
import store from './store';
import App from './App.vue';
import i18n from '@/locale';
import 'iview/dist/styles/iview.css';
import '@/styles/iconfont.css';
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './shared/filter.js';
import './shared/viewer';
import VueCropper from 'vue-cropper';
import MIS from './utils/mis';
import imgPreview from '@/views/components/imgPreview';
import { checkBtnAuth } from '@/utils/functions';
import { addWaterMarker, removeWaterMarker } from './utils/watermark';

JSON.parse = JsonParseBigInt;

MIS.token();
Vue.use(VueRouter)
Vue.prototype.$eventBus = new Vue();
Vue.use(VueCropper)
Vue.use(Viewer);
Vue.use(iView);
Vue.use(ElementUI)//, { locale }
Vue.use(imgPreview);

Vue.directive('btnAuth', {
  update(el, binding, vnode) {
    let permissionValue = binding.value // 获取到 v-btnAuth的值
    if (permissionValue) {
      let menuList = vnode.context.$store.state.app.menuList; //获取到菜单列表
      let { menuCode, btnCode } = permissionValue
      let isHasPermission = checkBtnAuth(menuList, menuCode, btnCode)
      if (!isHasPermission) {  // 没有权限 移除Dom元素
        // el.parentNode && el.parentNode.removeChild(el)
        el.style.visibility = 'hidden'
      } else {
        el.style.visibility = 'visible'
      }
    } else {
      throw new Error('需要传key')
    }
  }
})

function setWaterMarker() {
  // 等待user加载完成
  const timer = setInterval(() => {
    if (store.state.user.userDetail && store.state.user.userDetail.id) {
      addWaterMarker(`${store.state.user.userDetail.name}-${store.state.user.userDetail.id}`, store.state.user.technical);
      clearInterval(timer);
    }
  }, 200);
}

let router = null;
let instance = null;
function render(props = {}) {
  const { container } = props;
  router = new VueRouter({
    // mode: 'history',
    routes,
  });

  router.beforeEach((route, from, next) => {
    if (route.path === '/middle') {
      removeWaterMarker()
      next();
    } else if (!MIS.getToken()) {
      removeWaterMarker()
      MIS.removeToken();
      MIS.logout(window.location.href);
    } else {
      setWaterMarker();
      next();
    }
  });
  
  router.afterEach(() => {
    window.scrollTo(0, 0);
    if (document.querySelector('.single-page-con')) {
      document.querySelector('.single-page-con').scrollTop = 0;
    }
  });

  instance = new Vue({
    router,
    store,
    i18n,
    data: {
      currentPageName: '',
      createStepForm: {},
      spotGoodsAuditingDetail: {},
      uploadPurchansePlanData: null
    },
    render: (h) => h(App),
  }).$mount(container ? container.querySelector('#app') : '#app');
}

// 独立运行时
if (!window.__POWERED_BY_QIANKUN__) {
  render();
}

export async function bootstrap() {
  console.log('[vue] merchant app bootstraped');
}
export async function mount(props) {
  console.log('[vue] props from main framework', props);
  render(props);
}
export async function unmount() {
  removeWaterMarker()
  instance.$destroy();
  instance.$el.innerHTML = '';
  instance = null;
  router = null;
}
